import { useParams } from 'react-router-dom';
import { L2DetailContainer } from './L2Container';
import {
  useGetScoreDetails,
  useGetHealthBoosterAndBlocker,
  useGetDoctorsNotes,
  useGetCommonlyLinkedSymptoms,
} from '@viome/viome-base/src/usecase/Health/HealthQuery';
import {
  ScoreLevel,
  IScoreDetailResponse,
  IDoctorsNoteResponse,
  BoosterAndBlockerSummaryResponse,
} from '@viome/viome-base/src/usecase/Health/Health.model';
import { ErrorLoadingPage } from '@screens/ErrorHandling/ErrorLoadingPage';

export const L2DetailPage = () => {
  const { id } = useParams();

  const {
    data: scoreData,
    isLoading: scoreIsLoading,
    isError: scoreIsError,
  } = useGetScoreDetails(ScoreLevel.L2, Number(id));

  const {
    data: boosterData,
    isLoading: boosterIsLoading,
    isError: boosterIsError,
  } = useGetHealthBoosterAndBlocker(Number(id));

  const {
    data: doctorsData,
    isLoading: doctorsIsLoading,
    isError: doctorsIsError,
  } = useGetDoctorsNotes(ScoreLevel.L2, Number(id));

  const { data: commonlyLinkedSymptoms } = useGetCommonlyLinkedSymptoms(
    Number(id),
  );

  const isError = scoreIsError && boosterIsError && doctorsIsError;

  if (isError) {
    return <ErrorLoadingPage variant="dark" />;
  }

  const score: IScoreDetailResponse = scoreData || {
    about: '',
    contributing_scores: 0,
    image_url: '',
    rank: '',
    rank_color: '',
    score: 0,
    title: '',
    trend: [],
    related_health_zones: [],
  };

  const boosters: BoosterAndBlockerSummaryResponse | null = boosterData || {
    count: 0,
    image_url: [],
  };
  const doctorNotes: IDoctorsNoteResponse = doctorsData || [];

  return (
    <div className="dark bg-black h-full w-full">
      <L2DetailContainer
        score={score}
        doctorNotes={doctorNotes}
        boosters={boosters}
        isBoostersLoading={boosterIsLoading}
        isDoctorsNoteLoading={doctorsIsLoading}
        isHeaderError={scoreIsError}
        isBoosterError={boosterIsError}
        isDoctorError={doctorsIsError}
        commonlyLinkedSymptoms={commonlyLinkedSymptoms}
        isHeaderLoading={scoreIsLoading}
        scoreId={Number(id)}
      />
    </div>
  );
};
